@if (errors$ | async; as errors) {
  @for (error of errors; track $index) {
    <nwx-toast [error]="error"></nwx-toast>
  }
}
